// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__ulqYX","footer":"ChangeClinic_footer__1fOly"};